import { Color, Flex, Range, Radios, Text } from "src/elements";
import { RulesSectionContainer } from "./RulesSectionContainer";

interface SliderCardProps<T> {
  title: string;
  description: string;
  parentRadioConfig?: {
    options: Array<{ label: string; value: T }>;
    selection: T;
    onSelect: (value: T) => void;
  };
  sliderValue: number;
  onSliderChange: (value: number) => void;
  isDisabled?: boolean;
  area: string;
  leftLabel?: string;
  rightLabel?: string;
}

export const SliderCard = <T,>({
  area,
  title,
  description,
  parentRadioConfig,
  sliderValue,
  onSliderChange,
  isDisabled,
  leftLabel = "Allow",
  rightLabel = "Disallow",
}: SliderCardProps<T>) => (
  <RulesSectionContainer title={title} area={area} isDisabled={isDisabled}>
    <Flex column gap="10px">
      {parentRadioConfig && (
        <Radios
          options={parentRadioConfig.options}
          value={parentRadioConfig.selection}
          setValue={parentRadioConfig.onSelect}
          isDisabled={isDisabled}
          direction="row"
        />
      )}
      <Text variant="small2" color={isDisabled ? Color.textDisabled : Color.textMain}>
        {description}
      </Text>
      <Range
        min={0}
        max={100}
        step={1}
        value={sliderValue}
        setValue={onSliderChange}
        valueLabel={sliderValue}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        isDisabled={isDisabled}
      />
    </Flex>
  </RulesSectionContainer>
);
